module.exports = __webpack_public_path__ + "img/e2.c46b275d.png";